import {
  isBigResultsPitchCarouselVariant,
  isBigResultsPitchMockupVariant,
  isGoalPitchMockupVariant,
  isSocialProofMillionsVariant,
} from 'data/images/utils'
import type { ImagesDefinition } from 'types/images'

export const M01_IMAGES = {
  welcomeAgeBuckets: {
    heroBackground: {
      width: 651,
      height: 651,
      srcSet: [
        '/images/m01/memoji/welcome-age-buckets/hero_background.webp',
        '/images/m01/memoji/welcome-age-buckets/hero_background@2x.webp',
      ],
    },
    heroBackgroundDesktop: {
      width: 1436,
      height: 651,
      srcSet: [
        '/images/m01/memoji/welcome-age-buckets/hero_background_desktop.webp',
        '/images/m01/memoji/welcome-age-buckets/hero_background_desktop@2x.webp',
      ],
    },
  },
  socialProofMillions: {
    pitch: {
      width: 370,
      height: 364,
      srcSet: [
        '/images/m01/memoji/social_proof_millions.webp',
        '/images/m01/memoji/social_proof_millions@2x.webp',
      ],
      prefetchCondition: isSocialProofMillionsVariant('default'),
    },
    group: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/m01/memoji/social-proof-millions/group.webp',
        '/images/m01/memoji/social-proof-millions/group@2x.webp',
      ],
      prefetchCondition: isSocialProofMillionsVariant('group'),
    },
  },
  experience: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/m01/memoji/experience.webp',
        '/images/m01/memoji/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/m01/memoji/experience_pitch.webp',
        '/images/m01/memoji/experience_pitch@2x.webp',
      ],
    },
  },
  mainGoal: {
    gainMuscle: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/m01/memoji/main-goal/main_goal_option_gain_muscle.webp',
        '/images/m01/memoji/main-goal/main_goal_option_gain_muscle@2x.webp',
      ],
    },
    improveFitness: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/m01/memoji/main-goal/main_goal_option_improve_fitness.webp',
        '/images/m01/memoji/main-goal/main_goal_option_improve_fitness@2x.webp',
      ],
    },
    loseWeight: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/m01/memoji/main-goal/main_goal_option_lose_weight.webp',
        '/images/m01/memoji/main-goal/main_goal_option_lose_weight@2x.webp',
      ],
    },
  },
  struggle: {
    back: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/m01/memoji/struggle/struggle_option_back.webp',
        '/images/m01/memoji/struggle/struggle_option_back@2x.webp',
      ],
    },
    knees: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/m01/memoji/struggle/struggle_option_knees.webp',
        '/images/m01/memoji/struggle/struggle_option_knees@2x.webp',
      ],
    },
    none: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/m01/memoji/struggle/struggle_option_none.webp',
        '/images/m01/memoji/struggle/struggle_option_none@2x.webp',
      ],
    },
  },
  bodyTypePitch: {
    endomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/m01/memoji/body-type-pitch/body_type_pitch_endomorph.webp',
        '/images/m01/memoji/body-type-pitch/body_type_pitch_endomorph@2x.webp',
      ],
    },
    mesomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/m01/memoji/body-type-pitch/body_type_pitch_mesomorph.webp',
        '/images/m01/memoji/body-type-pitch/body_type_pitch_mesomorph@2x.webp',
      ],
    },
    ectomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/m01/memoji/body-type-pitch/body_type_pitch_ectomorph.webp',
        '/images/m01/memoji/body-type-pitch/body_type_pitch_ectomorph@2x.webp',
      ],
    },
  },
  strugglePitch: {
    knees: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/m01/memoji/struggle-pitch/struggle_pitch_knees.webp',
        '/images/m01/memoji/struggle-pitch/struggle_pitch_knees@2x.webp',
      ],
    },
    back: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/m01/memoji/struggle-pitch/struggle_pitch_back.webp',
        '/images/m01/memoji/struggle-pitch/struggle_pitch_back@2x.webp',
      ],
    },
    both: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/m01/memoji/struggle-pitch/struggle_pitch_both.webp',
        '/images/m01/memoji/struggle-pitch/struggle_pitch_both@2x.webp',
      ],
    },
  },
  physicalBuild: {
    extra: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/m01/memoji/physical-build/physical_build_option_significantly_overweight.webp',
        '/images/m01/memoji/physical-build/physical_build_option_significantly_overweight@2x.webp',
      ],
    },
    plusSize: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/m01/memoji/physical-build/physical_build_option_bigger.webp',
        '/images/m01/memoji/physical-build/physical_build_option_bigger@2x.webp',
      ],
    },
    average: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/m01/memoji/physical-build/physical_build_option_medium_build.webp',
        '/images/m01/memoji/physical-build/physical_build_option_medium_build@2x.webp',
      ],
    },
    skinnySlim: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/m01/memoji/physical-build/physical_build_option_slender.webp',
        '/images/m01/memoji/physical-build/physical_build_option_slender@2x.webp',
      ],
    },
  },
  bodyGoal: {
    bitLeaner: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/m01/memoji/body-goal/body_goal_option_a_bit_leaner.webp',
        '/images/m01/memoji/body-goal/body_goal_option_a_bit_leaner@2x.webp',
      ],
    },
    athletic: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/m01/memoji/body-goal/body_goal_option_athletic.webp',
        '/images/m01/memoji/body-goal/body_goal_option_athletic@2x.webp',
      ],
    },
    shredded: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/m01/memoji/body-goal/body_goal_option_shredded.webp',
        '/images/m01/memoji/body-goal/body_goal_option_shredded@2x.webp',
      ],
    },
    extraBulky: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/m01/memoji/body-goal/body_goal_option_extra_bulky.webp',
        '/images/m01/memoji/body-goal/body_goal_option_extra_bulky@2x.webp',
      ],
    },
  },
  problemAreas: {
    belly: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/m01/memoji/problem-areas/problem_areas_option_belly.webp',
        '/images/m01/memoji/problem-areas/problem_areas_option_belly@2x.webp',
      ],
    },
    pecs: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/m01/memoji/problem-areas/problem_areas_option_pecs.webp',
        '/images/m01/memoji/problem-areas/problem_areas_option_pecs@2x.webp',
      ],
    },
    arms: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/m01/memoji/problem-areas/problem_areas_option_arms.webp',
        '/images/m01/memoji/problem-areas/problem_areas_option_arms@2x.webp',
      ],
    },
    thighs: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/m01/memoji/problem-areas/problem_areas_option_legs.webp',
        '/images/m01/memoji/problem-areas/problem_areas_option_legs@2x.webp',
      ],
    },
  },
  problemAreasPitch: {
    mockup: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/m01/memoji/problem-areas-pitch/problem_areas_pitch_mockup_{{locale}}.webp',
        '/images/m01/memoji/problem-areas-pitch/problem_areas_pitch_mockup_{{locale}}@2x.webp',
      ],
    },
  },
  howOftenExercise: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/m01/memoji/how_often_exercise.webp',
        '/images/m01/memoji/how_often_exercise@2x.webp',
      ],
    },
  },
  howOftenWalks: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/m01/memoji/how_often_walks.webp',
        '/images/m01/memoji/how_often_walks@2x.webp',
      ],
    },
  },
  flexible: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/m01/memoji/flexible.webp',
        '/images/m01/memoji/flexible@2x.webp',
      ],
    },
  },
  bigResultsPitch: {
    first: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/m01/memoji/big-results-pitch/big_results_pitch_01.webp',
        '/images/m01/memoji/big-results-pitch/big_results_pitch_01@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchCarouselVariant,
    },
    second: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/m01/memoji/big-results-pitch/big_results_pitch_02.webp',
        '/images/m01/memoji/big-results-pitch/big_results_pitch_02@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchCarouselVariant,
    },
    third: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/m01/memoji/big-results-pitch/big_results_pitch_03.webp',
        '/images/m01/memoji/big-results-pitch/big_results_pitch_03@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchCarouselVariant,
    },
    mockup: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/m01/memoji/big-results-pitch/big_results_pitch_mockup_{{locale}}.webp',
        '/images/m01/memoji/big-results-pitch/big_results_pitch_mockup_{{locale}}@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchMockupVariant,
    },
  },
  goalPitch: {
    mockup: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/m01/memoji/goal-pitch/goal_pitch_mockup_{{locale}}.webp',
        '/images/m01/memoji/goal-pitch/goal_pitch_mockup_{{locale}}@2x.webp',
      ],
      prefetchCondition: isGoalPitchMockupVariant,
    },
  },
  waterIntake: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/m01/memoji/water_intake.webp',
        '/images/m01/memoji/water_intake@2x.webp',
      ],
    },
  },
  sleepDuration: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/m01/memoji/sleep_duration.webp',
        '/images/m01/memoji/sleep_duration@2x.webp',
      ],
    },
  },
  wellnessProfile: {
    extended: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/m01/memoji/wellness-profile/wellness_profile_overweight.webp',
        '/images/m01/memoji/wellness-profile/wellness_profile_overweight@2x.webp',
      ],
    },
    fullFigured: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/m01/memoji/wellness-profile/wellness_profile_bigger.webp',
        '/images/m01/memoji/wellness-profile/wellness_profile_bigger@2x.webp',
      ],
    },
    midSized: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/m01/memoji/wellness-profile/wellness_profile_medium_build.webp',
        '/images/m01/memoji/wellness-profile/wellness_profile_medium_build@2x.webp',
      ],
    },
    slim: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/m01/memoji/wellness-profile/wellness_profile_slender.webp',
        '/images/m01/memoji/wellness-profile/wellness_profile_slender@2x.webp',
      ],
    },
  },
  subscription: {
    beforeBigger: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_before_bigger.webp',
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_before_bigger@2x.webp',
      ],
    },
    beforeMediumBuild: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_before_medium_build.webp',
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_before_medium_build@2x.webp',
      ],
    },
    beforeSignificantlyOverweight: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_before_significantly_overweight.webp',
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_before_significantly_overweight@2x.webp',
      ],
    },
    beforeSlender: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_before_slender.webp',
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_before_slender@2x.webp',
      ],
    },
    afterAthletic: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_after_athletic.webp',
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_after_athletic@2x.webp',
      ],
    },
    afterBitLeaner: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_after_a_bit_leaner.webp',
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_after_a_bit_leaner@2x.webp',
      ],
    },
    afterExtraBulky: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_after_extra_bulky.webp',
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_after_extra_bulky@2x.webp',
      ],
    },
    afterShredded: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_after_shredded.webp',
        '/images/m01/memoji/subscription/goal-body/paywall_comparison_after_shredded@2x.webp',
      ],
    },
  },
} satisfies ImagesDefinition
